import React from 'react';

const WhatsAppButton = () => {
  return (
    <a className="fixed bottom-8 right-8 w-16 h-16 bg-secondary text-white rounded-full flex items-center justify-center shadow-2xl z-[100] hover:scale-110 transition-all float-animation" href="https://wa.me/919426532062?text=Hi!%20I%20need%20some%20help." target="_blank" rel="noreferrer">
      <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="w-8 h-8" />
    </a>
  );
};

export default WhatsAppButton;
